import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { APP_STORE } from '@stores/app.store';

export const CLIENT_INTERCEPTOR: HttpInterceptorFn = (req, next) => {
  const appStore = inject(APP_STORE);

  const clientId = appStore.selectedClientId();

  if (clientId) {
    req = req.clone({ setHeaders: { ClientId: clientId } });
  }

  return next(req);
};
